<template>
  <div>
    <el-row :gutter="15">
      <el-col>
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-quyu el-icon--left"></i>报表生成
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入模板名称" v-model="queryObj.name" size="small" class="query" style="float: left"
              clearable @change="() => {
                  this.queryObj.pageNum = 1;
                  loadRosteringTypeList();
                }
                ">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>

          <el-table style="top:6px;" :data="pageData.list" ref="templateTable" border stripe size="mini"
            height="calc(100vh - 250px)" v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="name" label="模板名称"> </el-table-column>
            <el-table-column prop="tempFile" label="模板文件">
              <template slot-scope="scope">
                <a class="template-link" @mouseover="setLinkStyle($event.target)"
                  @mouseout="resetLinkStyle($event.target)" @click="downFile(scope.row)">{{
                    scope.row.tempFile == null
                    ? ""
                    : JSON.parse(scope.row.tempFile)[0].name
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="edit_init(scope.row)">生成报表</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData" @change="(cpage) => {
                this.queryObj.pageNum = cpage;
                this.loadRosteringTypeList();
              }
              ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="editVisible" width="600px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>生成报表
      </span>

      <el-row>
        <el-form :model="reportInfo" size="mini" label-position="right" label-width="110px" inline-message: true>
          <div class="es-op-box">
            <el-date-picker style="float: left; width: 300px; margin-bottom: 10px" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" v-model="reportInfo.dateTime" type="daterange" size="small" class="query"
              range-separator="至" start-placeholder="日期起始" end-placeholder="日期结束" clearable>
            </el-date-picker>
          </div>
          <el-col :span="24">
            <el-card class="card" style="overflow: auto; height: calc(100vh - 350px)">
              <div slot="header" class="card-header">
                <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>组织权限
              </div>
              <div style="overflow: auto; height: calc(100vh - 415px)">
                <es-org-tree @clickByOrg="selectOrgIdsList" :checkstrictly="false" ref="orgTreeChildren"></es-org-tree>
              </div>
            </el-card>
          </el-col>
        </el-form>
      </el-row>

      <span slot="footer">
        <el-button size="mini" @click="exit">取 消</el-button>
        <el-button type="primary" size="mini" @click="add()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "createReport",
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      reportInfo: {}, //模板信息
      loading: false,
      saving: false,
      orgIds: [],
    };
  },
  methods: {
    exit () {
      this.editVisible = false;
      this.reportInfo = {};
      this.$refs["orgTreeChildren"].load_orgTree();
      this.orgIds = [];
    },
    selectOrgIdsList (orgIds) {
      this.orgIds = orgIds;
      console.log(this.orgIds);
    },
    //页面初始化
    init () {
      this.loadRosteringTypeList();
    },
    //从后台查询区域列表
    loadRosteringTypeList () {
      this.loading = true;
      this.$ajax
        .get("/buss/template/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加区域
    add_init () {
      this.editVisible = true;
    },
    //初始化编辑区域
    edit_init (row) {
      this.editVisible = true;
      console.log(row);
      this.reportInfo = JSON.parse(JSON.stringify(row));
      console.log(this.reportInfo);
    },
    //生成报表
    add () {
      console.log(this.orgIds);
      console.log(this.reportInfo.dateTime);
      if (this.orgIds.length >= 1 && this.reportInfo.dateTime != null) {
        let orgids = this.orgIds.join(",");
        console.log(orgids);
        let startDate = this.reportInfo.dateTime[0];
        let endDate = this.reportInfo.dateTime[1];
        let list = JSON.parse(this.reportInfo.tempFile)[0];
        let s = list.url.indexOf("=");
        let e = list .url.length;
        let filename = list.url.substring(s + 1, e);

        let url = "/buss/reportword/getReport";
        this.$ajax
          .downFile(url, {
            filename: filename,
            startDate: startDate,
            endDate: endDate,
            orgIds: orgids,
            tempName: this.reportInfo.name,
          })
          .then((msg) => {
            this.editVisible = false;
            this.reportInfo = {};
            this.$refs["orgTreeChildren"].load_orgTree();
            this.orgIds = [];
            this.$message.success(msg);
          })
          .catch((err) => {
            this.reportInfo = {};
            this.$refs["orgTreeChildren"].load_orgTree();
      this.orgIds = [];
            this.$message.error(err);
            this.editVisible = false;
          });
      } else {
        this.$message.info("请选择生成日期和组织!");
      }
    },

    downFile (row) {
      let list = JSON.parse(row.tempFile)[0];
      this.loadingFile = true;
      const x = new window.XMLHttpRequest();
      x.open(
        "GET",
        this.$api +
        list.url +
        "&platform=web&token=" +
        this.$store.getUser().token,
        true
      );
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = list.name;
        a.click();
        this.loadingFile = false;
      };
      x.send();
      this.loadingFile = false;
    },

    setLinkStyle (target) {
      target.style.color = "#409EFF";
      target.style.textDecoration = "underline";
      target.style.cursor = "pointer";
    },
    resetLinkStyle (target) {
      target.style.color = "";
      target.style.textDecoration = "none";
      target.style.cursor = "";
    },
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped>
.template-link {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;
}

.template-link:hover {
  text-decoration: underline;
}
</style>
